<template>
  <div class="row">
    <div class="col-12 d-flex justify-content-center align-items-center">
      <button
        :disabled="processing"
        class="btn btn-primary mt-5"
        @click="goToUnsubscribe"
        >
        I want to unsubscribe
      </button>
    </div>
  </div>
</template>


<script>

import { myCalendarService } from "@/_services";
export default {
  name: 'Unsubscribe',

  data() {
    return {
      processing: false
    };
  },

  methods: {
    goToUnsubscribe(){
      const data = {
         activity_type_id: 2,
         campaign_step_hash: this.$route.params.campaign_step_hash,
         business_contact_hash: this.$route.params.business_contact_hash
      }

      this.processing = true
      myCalendarService.unsubscribe(data)
      .then(res => {
        console.log(res)
        this.loadingBlacklist = false;
              this.total = 0;
              this.$swal({
                type: "success",
                title: "Done!",
                text: "",
                showCancelButton: false,
              })

      })
      .catch(err => {
        this.processing = false
        console.log(err)
            this.$swal({
            type: "error",
            title: "Error",
            text: "",
            showCancelButton: false,
          })
      })

    }
  },
};
</script>
